import { DropdownMenuItem as MenuItem } from '@radix-ui/react-dropdown-menu'
import {
    getBaseItemClassNames,
    getBaseItemContainerClassNames,
} from './Dropdown.styles'
import { DropdownMenuItemProps } from './Dropdown.types'

/**
 *
 * @param onSelect - Callback function to be called when the item is selected
 * @param children - The content of the item
 * @param itemContainerClassNames - The classNames to be applied to the item container
 * @param itemClassNames - The classNames to be applied to the item
 */

export const DropdownMenuItem = ({
    onSelect,
    children,
    itemContainerClassNames,
    itemClassNames,
}: DropdownMenuItemProps) => {
    return (
        <MenuItem
            onSelect={onSelect}
            className={getBaseItemContainerClassNames(itemContainerClassNames)}
        >
            <div
                className={getBaseItemClassNames(itemClassNames)}
                id="dropdown"
            >
                {children}
            </div>
        </MenuItem>
    )
}
